// extracted by mini-css-extract-plugin
export default {"root":"Xo6C+rs","required":"Uc5cqA-"};